export const inspections = [
  { path: 'created', title: 'Creación', icon: 'mdi-calendar-blank-outline' },
  { path: 'inspector.name', title: 'Inspector', icon: 'mdi-account' },
  { path: 'address.type.description', title: 'Ubicación', icon: 'mdi-map-marker-outline' },
  { path: 'address', title: 'Dirección', icon: 'mdi-map-marker-outline' },
  { path: 'supervisor.name', title: 'Supervisor', icon: 'mdi-account' },
]
